import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
//@ts-ignore webpack 5 require without *
import tinycolor from 'tinycolor2';
import { Avatar, Box, MenuItem, Select, Typography, } from '@mui/material';
import Rainbow from 'console/images/device-settings-dialog/rainbow.svg';
import { ControlWithoutValidation } from 'console/shared/components/fields/control/without-validation';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
export const boiler_adapter_ot_color = ['#be0000', 'тёмно-красный'];
export const colors = [
    ['#a05be5', 'фиолетовый'],
    ['#e55bce', 'розовый'],
    ['#e57272', 'приглушённый розовый'],
    ['#e50000', 'красный'],
    ['#16a0e5', 'синий'], //4
    ['#9accdf', 'приглушённый синий'],
    ['#00e5e5', 'голубой'],
    ['#00d600', 'ярко-зелёный'],
    ['#F6D03A', 'жёлтый'],
    ['#bbe500', 'салатовый'], //9
    ['#89a800', 'зелёный'],
    ['#00a889', 'цвет волны'],
    ['#e99455', 'рыжий'],
    ['#99540f', 'коричневый'],
    ['#9e9e9e', 'серый'], //14
    ['#c5c5c5', 'светло-серый'],
];
export const autoscan_track_colors = [
    ['#c4443b', 'красный а+'],
    ...colors,
];
export const darken_colors = colors.map(([color]) => {
    if (color === '#00d600') {
        return '#33aa66';
    }
    else {
        return tinycolor(color).darken().toString();
    }
});
export function getModeColor(mode, mode_index) {
    if (HeatingMode.hasManualColor(mode)) {
        return darken_colors[HeatingMode.getManualColor(mode)];
    }
    return darken_colors[HeatingMode.getAutoColor(mode_index)];
}
function MaterialColorDropdown(props) {
    const null_str = '[null]';
    const onChange = useCallback((ev) => {
        if (ev.target.value == null_str)
            props.onChange(0);
        else
            props.onChange(+ev.target.value);
    }, [props.onChange]);
    const options = useMemo(() => [
        {
            text: 'Авто',
            value: 0,
            color: 'transparent',
        },
        ...colors.map(([color, text], index) => ({
            text,
            value: (index << 1) + 1,
            color,
        })),
    ], [colors]);
    return (_jsx(Select, { fullWidth: true, margin: "dense", label: props.label, value: props.value.toString(), onChange: onChange, disabled: !!props.disabled, children: options.map(({ text, color, value }, i) => (_jsx(MenuItem, { value: value ?? null_str, children: _jsxs(Box, { display: "flex", alignItems: "center", children: [_jsx(Avatar, { style: { backgroundColor: color, color }, sx: { width: 24, height: 24 }, children: value === 0 ? _jsx(Rainbow, {}) : 'C' }), _jsx(Box, { ml: 2, children: _jsx(Typography, { variant: "subtitle1", color: "textPrimary", children: text }) })] }) }, i))) }));
}
export const MaterialColorPicker4bit = memo(function MaterialColorPicker4bit(props) {
    const { value, onChange } = props;
    return (_jsx(ControlWithoutValidation, { label: "\u0426\u0432\u0435\u0442", value: value, onChange: onChange, field: MaterialColorDropdown }));
});
const string_hash = (s) => {
    let sum = 0;
    for (let i = 0; i < s.length; i++)
        sum += s.charCodeAt(i);
    return sum % colors.length;
};
export function getSensorColor(objNS, obj) {
    if (obj == null) {
        return colors[0][0];
    }
    //авто-цвет
    if (!objNS.isManualColor(obj)) {
        const str = 'serial' in obj && typeof obj.serial === 'string'
            ? obj.serial
            : 'physical_input_num' in obj
                ? obj.physical_input_num.toString()
                : '';
        return colors[string_hash(str)][0];
    }
    const color_index = objNS.getColor(obj) >> 1;
    return colors[color_index][0];
}
